import React from 'react';
import ContentHeader from 'legacy/containers/ContentHeader';
import styles from './AccessDeniedContent.css';

function AccessDeniedContent(props) {
  return (
    <React.Fragment>
      <ContentHeader
        text={props.title || ''}
        showAddPatient={false}
        showLastRefresh={false}
      />
      <div
        className={styles.contentWrapper}
        style={{
          height: '100%',
        }}
      >
        <h1 className={styles.accessErrorHeadline}>Access Denied</h1>
        <p className={styles.accessErrorDesc}>
          Sorry, your practice does not have access rights to this feature.
        </p>
        <p className={styles.accessErrorInstr}>
          Please contact your administrator for assistance.
        </p>
      </div>
    </React.Fragment>
  );
}

export default AccessDeniedContent;



// WEBPACK FOOTER //
// ./src/views/components/AccessDeniedContent/AccessDeniedContent.jsx